import Vue from 'vue'
Vue.component('my-table', () => import('./table.vue'))
Vue.component('my-search', () => import('./search.vue'))
Vue.component('my-details', () => import('./details.vue'))
// Vue.component('my-upload', () => import('./upload.vue'))
Vue.component('my-upload', () => import('./uploadNew.vue'))
Vue.component('my-upload2', () => import('./uploadNew2.vue'))
Vue.component('my-uploadFile', () => import('./uploadFile.vue'))
Vue.component('my-pdf', () => import('./pdf.vue'))
